export default function HistoriaTimeline() {
  return (
    <section id="historia" className="py-16 md:py-28 bg-background-50">
      <div className="px-4 md:px-6 lg:px-10">
        <div className="max-w-6xl mx-auto">
          {/* Section Header */}
          <div className="text-center mb-14 md:mb-20">
            <span className="inline-block text-xs md:text-sm font-semibold uppercase tracking-widest text-primary-600 mb-3">
              Trayectoria institucional
            </span>
            <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-900 leading-tight">
              Nuestra Historia
            </h2>
          </div>

          {/* Narrative with building image */}
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-14 items-start">
            {/* Text column */}
            <div className="flex-1 lg:max-w-[55%]">
              <div className="text-foreground-700 text-base leading-[1.85] text-justify space-y-5">
                <p>
                  El 22 de julio de 2011, un grupo de artistas intérpretes y ejecutantes musicales constituyó la Sociedad Nacional de Intérpretes y Ejecutantes de la Música — SONIEM — con la firme finalidad de gestionar colectivamente los derechos que les correspondían como creadores de interpretaciones y ejecuciones musicales. Este paso decisivo marcó el inicio de una organización pensada por artistas y para artistas, con la vocación de transformar la realidad de la gestión de derechos en el Perú.
                </p>
                <p>
                  Ese mismo año, mediante la Resolución N.º 0054-2011/DDA-INDECOPI, el Estado peruano autorizó el funcionamiento de SONIEM como sociedad de gestión colectiva, dotando a la institución de reconocimiento legal y respaldo institucional. Con esta autorización, SONIEM se integró al sistema de protección de la propiedad intelectual del país, asumiendo el compromiso de representar, administrar y defender los derechos de los artistas musicales de manera transparente y democrática.
                </p>
                <p>
                  En 2012, la sociedad inició la administración práctica de los derechos de sus primeros afiliados, sentando las bases de un sistema de recaudación y distribución diseñado para ser equitativo y eficiente. Cada cobro, cada distribución y cada acuerdo se construyó con la rigurosidad que merecían los artistas que habían depositado su confianza en la institución.
                </p>
                <p>
                  El crecimiento de SONIEM trascendió fronteras en 2014, año en que se firmaron los primeros convenios de representación recíproca con sociedades de gestión de América Latina. Esta integración a la red internacional permitió extender la protección de los artistas afiliados más allá del territorio peruano y, al mismo tiempo, representar en el país los derechos de intérpretes y ejecutantes de otras naciones, ampliando el alcance y el impacto de la gestión colectiva.
                </p>
                <p>
                  El fortalecimiento institucional se consolidó decisivamente en 2018, con la ampliación de la estructura organizativa, el crecimiento de la base de afiliados y la modernización de los sistemas de identificación y distribución. SONIEM evolucionó hacia una institución más robusta, capaz de responder a las demandas de un sector artístico en constante transformación y de una industria musical cada vez más digital.
                </p>
                <p>
                  Hoy, SONIEM representa a más de 3,300 artistas musicales y continúa expandiendo su red de convenios internacionales. La sociedad se ha consolidado como referente en la gestión colectiva del Perú, manteniendo viva la promesa original de sus fundadores: proteger los derechos de los artistas con transparencia, democracia y compromiso, mientras impulsa el desarrollo cultural de la música peruana en el ámbito nacional e internacional.
                </p>
              </div>
            </div>

            {/* Building image column */}
            <div className="w-full lg:w-[45%] lg:sticky lg:top-28 flex flex-col gap-6">
              <div className="relative rounded-2xl overflow-hidden bg-background-100 border border-secondary-200/60">
                <div className="relative w-full aspect-[4/5]">
                  <img
                    src="https://storage.helloreaddy.io/project_files/b36b426b-b2cb-46b2-8bd1-3f029dd7b0e4/5aba6df9-0500-42fc-a036-a535373138b1_compressed_WhatsApp-Image-2024-11-26-at-1.02.10-PM-3.webp"
                    alt="Sede institucional de SONIEM — Edificio de la Sociedad Nacional de Intérpretes y Ejecutantes de la Música"
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/25 via-transparent to-transparent" />
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                  <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-background-50/90 backdrop-blur-sm border border-secondary-200/60">
                    <div className="w-2 h-2 rounded-full bg-primary-500 animate-pulse" />
                    <span className="text-xs font-semibold text-foreground-800 whitespace-nowrap">
                      Sede institucional
                    </span>
                  </div>
                </div>
              </div>

              {/* Milestone highlights */}
              <div className="grid grid-cols-2 gap-3">
                <div className="rounded-xl bg-background-100 border border-secondary-200/60 p-4 text-center">
                  <span className="block font-heading text-2xl font-bold text-primary-600">2011</span>
                  <span className="text-xs text-foreground-600 mt-1 block leading-snug">Fundación y autorización INDECOPI</span>
                </div>
                <div className="rounded-xl bg-background-100 border border-secondary-200/60 p-4 text-center">
                  <span className="block font-heading text-2xl font-bold text-primary-600">3,300+</span>
                  <span className="text-xs text-foreground-600 mt-1 block leading-snug">Artistas representados</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}